import { useEffect, useState } from 'react';
import { Dialog, DialogTitle, Button, TextField, DialogContent, DialogActions, Stack } from '@mui/material';

interface Props {
  firstName: string;
  lastName: string;
  open: boolean;
  onClose(): void;
  update(firstName: string, lastName: string): void;
}

export function UpdateNameDialog({ firstName, lastName, open, onClose, update }: Props) {
  const [first, setFirst] = useState(firstName);
  const [last, setLast] = useState(lastName);

  useEffect(() => {
    if (open) {
      setFirst(firstName);
      setLast(lastName);
    }
  }, [open, firstName, lastName]);

  const commit = () => {
    update(first.trim(), last.trim());
    onClose();
  };

  const canSubmit = first.trim() !== '' && last.trim() !== '';

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ pb: 1 }}>Endre navn</DialogTitle>
      <DialogContent sx={{ pt: 1 }}>
        <Stack
          component="form"
          spacing={2}
          sx={{ pt: 1 }}
          onSubmit={(e) => {
            e.preventDefault();
            if (canSubmit) commit();
          }}>
          <TextField
            label="Fornavn"
            fullWidth
            autoFocus
            value={first}
            onChange={(e) => setFirst(e.target.value)}
          />
          <TextField
            label="Etternavn"
            fullWidth
            value={last}
            onChange={(e) => setLast(e.target.value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Avbryt</Button>
        <Button variant="contained" color="primary" onClick={commit} disabled={!canSubmit}>
          Lagre
        </Button>
      </DialogActions>
    </Dialog>
  );
}
